import { useEffect, useState } from "react";
import { Button, Input, message } from "antd";
import { ReactComponent as GolfIcon } from "icons/m2c-golf.svg";
import { ReactComponent as AnalyticsIcon } from "icons/analytics-project.svg";
import { ReactComponent as SimulationIcon } from "icons/simulationProject.svg";
import { ReactComponent as LaunchIcon } from "icons/m2c-launch.svg";
import { ReactComponent as AthelticsIcon } from "icons/athleticsLogo.svg";
import { ReactComponent as SelectedIcon } from "icons/selectedProject.svg";
import { UseLazyApiCallV2 } from "hooks/use-lazy-api-call-v2";
import { allProjects, allProjectsSandbox } from "pages/settings/constants";
import { useCurrentUserContext } from "providers";
import { AdminIcon } from "icons/adminIcon";
import { UserIcon } from "icons/user-icon";
import styles from "./styles.module.scss";
import { ENVIORNMENTS, getCurrentEnviornment } from "utils/constants";
import { ConditionalRenderer } from "components/conditonal-renderer";

export function EditUser({ refetch, setIsEditModalVisible, userData }: any) {
  const [email, setEmail] = useState(userData?.email);
  const [username, setName] = useState(userData?.username);
  const [userRole, setUserRole] = useState(userData?.role || "user");
  const [emailError, setEmailError] = useState("");
  const [selectedProjects, setSelectedProjects] = useState<any>(
    userData.projects,
  );

  const { refreshCurrentUser, user } = useCurrentUserContext();

  const [isButtonEnabled, setIsButtonEnabled] = useState(false);

  const [editUser] = UseLazyApiCallV2({
    url: null,
    method: "POST",
  }) as any;

  const handleEmailChange = (e: any) => {
    const value = e.target.value;
    setEmail(value);

    // Validate email format
    if (value && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
      setEmailError("Invalid email format");
    } else {
      setEmailError("");
    }
  };

  const validateForm = () => {
    // Check if email is valid
    const isEmailValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

    // Check if at least one project is selected
    const isProjectSelected = selectedProjects?.length > 0;

    const isUserName = username?.length >= 3;

    // Enable button if email is valid and at least one project is selected
    setIsButtonEnabled(isEmailValid && isProjectSelected && isUserName);
  };

  const handleProjectSelection = (project: any) => {
    if (selectedProjects.includes(project)) {
      setSelectedProjects(selectedProjects.filter((p: any) => p !== project));
    } else {
      setSelectedProjects([...selectedProjects, project]);
    }
  };

  const handleEditUser = async () => {
    try {
      const res = await editUser({
        url: "/edit_user",
        params: {
          email: email,
          username: username,
          projects: selectedProjects,
          role: userRole,
          loggedUser: user?.email,
        },
      });

      if (res.status === "Success") {
        refetch();
        await refreshCurrentUser();

        setIsEditModalVisible(false);
        message.success(res.message);
      } else {
      }
    } catch (error) {}
  };

  useEffect(() => {
    validateForm();
  }, [email, selectedProjects, username]);

  const isAdmin = user?.role === "admin";
  const projects =
    getCurrentEnviornment() === ENVIORNMENTS.LIVE
      ? allProjects
      : allProjectsSandbox;

  return (
    <div className={styles.mainContainer}>
      <div className={styles.email}>Name</div>
      <Input
        className={styles.emailInput}
        placeholder="Enter Name"
        value={username}
        allowClear
        disabled={!isAdmin}
        onChange={(event: any) => setName(event?.target?.value)}
      />
      <div className={styles.email}>Email Address</div>
      <Input
        className={styles.emailInput}
        placeholder="Enter email address"
        value={email}
        onChange={handleEmailChange}
        allowClear
        disabled
      />
      {emailError && <div className={styles.error}>{emailError}</div>}

      <div style={{ display: "flex", gap: "10px" }}>
        <div
          className={`${styles.admin} ${
            userRole === "admin" ? styles.active : ""
          }`}
          onClick={() => {
            setUserRole("admin");
            setSelectedProjects(projects);
          }}
        >
          <AdminIcon active={!!(userRole === "admin")} />
          Admin
        </div>
        <div
          className={`${styles.admin} ${
            userRole === "user" ? styles.active : ""
          }`}
          onClick={() => {
            setUserRole("user");
            setSelectedProjects(userData?.projects);
          }}
        >
          <UserIcon active={!!(userRole === "user")} />
          User
        </div>
      </div>

      <div className={styles.server}>Select Project</div>
      <ConditionalRenderer
        condition={getCurrentEnviornment() === ENVIORNMENTS.LIVE}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            paddingBottom: "20px",
          }}
        >
          <div
            className={`${styles.serverContainer} ${
              selectedProjects.includes("Motion2Coach Golf")
                ? styles.selected
                : ""
            }`}
            onClick={() => handleProjectSelection("Motion2Coach Golf")}
          >
            <div
              style={{
                height: "30px",
                display: "flex",
                alignSelf: "end",
                padding: "1px",
              }}
            >
              {selectedProjects.includes("Motion2Coach Golf") ? (
                <SelectedIcon />
              ) : (
                ""
              )}
            </div>
            <div style={{ width: "58px", height: "46px" }}>
              <GolfIcon style={{ width: "100%", height: "100%" }} />
            </div>
            <div className={styles.serverTitle}>Motion2Coach Golf</div>
          </div>
          <div
            className={`${styles.serverContainer} ${
              selectedProjects.includes("Motion2Coach Launch")
                ? styles.selected
                : ""
            }`}
            onClick={() => handleProjectSelection("Motion2Coach Launch")}
          >
            <div
              style={{
                height: "30px",
                display: "flex",
                alignSelf: "end",
                padding: "1px",
              }}
            >
              {selectedProjects.includes("Motion2Coach Launch") ? (
                <SelectedIcon />
              ) : (
                ""
              )}
            </div>
            <div style={{ width: "58px", height: "46px" }}>
              <LaunchIcon style={{ width: "100%", height: "100%" }} />
            </div>
            <div className={styles.serverTitle}>Motion2Coach Launch</div>
          </div>

          <div
            className={`${styles.serverContainer} ${
              selectedProjects.includes("Motion2Coach Athletics")
                ? styles.selected
                : ""
            }`}
            onClick={() => handleProjectSelection("Motion2Coach Athletics")}
          >
            <div
              style={{
                height: "30px",
                display: "flex",
                alignSelf: "end",
                padding: "1px",
              }}
            >
              {selectedProjects.includes("Motion2Coach Athletics") ? (
                <SelectedIcon />
              ) : (
                ""
              )}
            </div>
            <div style={{ width: "58px", height: "46px" }}>
              <AthelticsIcon style={{ width: "100%", height: "100%" }} />
            </div>
            <div className={styles.serverTitle}>Motion2Coach Athletics</div>
          </div>

          <div
            className={`${styles.serverContainer} ${
              selectedProjects.includes("Motion2Coach Simulation")
                ? styles.selected
                : ""
            }`}
            onClick={() => handleProjectSelection("Motion2Coach Simulation")}
          >
            <div
              style={{
                height: "30px",
                display: "flex",
                alignSelf: "end",
                padding: "1px",
              }}
            >
              {selectedProjects.includes("Motion2Coach Simulation") ? (
                <SelectedIcon />
              ) : (
                ""
              )}
            </div>
            <div style={{ width: "58px", height: "46px" }}>
              <SimulationIcon style={{ width: "100%", height: "100%" }} />
            </div>
            <div className={styles.serverTitle}>Motion2Coach Baseball</div>
          </div>

          <div
            className={`${styles.serverContainer} ${
              selectedProjects.includes("Motion2Coach Analytics")
                ? styles.selected
                : ""
            }`}
            onClick={() => handleProjectSelection("Motion2Coach Analytics")}
          >
            <div
              style={{
                height: "30px",
                display: "flex",
                alignSelf: "end",
                padding: "1px",
              }}
            >
              {selectedProjects.includes("Motion2Coach Analytics") ? (
                <SelectedIcon />
              ) : (
                ""
              )}
            </div>
            <div style={{ width: "58px", height: "46px" }}>
              <AnalyticsIcon style={{ width: "100%", height: "100%" }} />
            </div>
            <div className={styles.serverTitle}>Motion2Coach Analytics</div>
          </div>
        </div>
      </ConditionalRenderer>
      <ConditionalRenderer
        condition={getCurrentEnviornment() === ENVIORNMENTS.SANDBOX}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "start",
            paddingBottom: "20px",
            gap: "20px",
          }}
        >
          <div
            className={`${styles.serverContainer} ${
              selectedProjects.includes("Motion2Coach Golf")
                ? styles.selected
                : ""
            }`}
            onClick={() => handleProjectSelection("Motion2Coach Golf")}
          >
            <div
              style={{
                height: "30px",
                display: "flex",
                alignSelf: "end",
                padding: "1px",
              }}
            >
              {selectedProjects.includes("Motion2Coach Golf") ? (
                <SelectedIcon />
              ) : (
                ""
              )}
            </div>
            <div style={{ width: "58px", height: "46px" }}>
              <GolfIcon style={{ width: "100%", height: "100%" }} />
            </div>
            <div className={styles.serverTitle}>Motion2Coach Golf</div>
          </div>
          <div
            className={`${styles.serverContainer} ${
              selectedProjects.includes("Motion2Coach Launch")
                ? styles.selected
                : ""
            }`}
            onClick={() => handleProjectSelection("Motion2Coach Launch")}
          >
            <div
              style={{
                height: "30px",
                display: "flex",
                alignSelf: "end",
                padding: "1px",
              }}
            >
              {selectedProjects.includes("Motion2Coach Launch") ? (
                <SelectedIcon />
              ) : (
                ""
              )}
            </div>
            <div style={{ width: "58px", height: "46px" }}>
              <LaunchIcon style={{ width: "100%", height: "100%" }} />
            </div>
            <div className={styles.serverTitle}>Motion2Coach Launch</div>
          </div>
          <div
            className={`${styles.serverContainer} ${
              selectedProjects.includes("Motion2Coach Analytics")
                ? styles.selected
                : ""
            }`}
            onClick={() => handleProjectSelection("Motion2Coach Analytics")}
          >
            <div
              style={{
                height: "30px",
                display: "flex",
                alignSelf: "end",
                padding: "1px",
              }}
            >
              {selectedProjects.includes("Motion2Coach Analytics") ? (
                <SelectedIcon />
              ) : (
                ""
              )}
            </div>
            <div style={{ width: "58px", height: "46px" }}>
              <AnalyticsIcon style={{ width: "100%", height: "100%" }} />
            </div>
            <div className={styles.serverTitle}>Motion2Coach Analytics</div>
          </div>
        </div>
      </ConditionalRenderer>

      <div
        style={{
          marginTop: "10px",
          display: "flex",
          justifyContent: "flex-end",
        }}
      >
        <Button
          className={styles.addButton}
          onClick={handleEditUser}
          disabled={!isButtonEnabled}
        >
          Edit User
        </Button>
      </div>
    </div>
  );
}
